import { Typography } from '@mui/material';

import ShowDetailsModal from '../../components/ShowDetailsModal/ShowDetailsModal';
import { Info } from '../../types/KycTypes';

type Props = {
    info?: Info | null;
};

const inlineStyles = { color: 'text.secondary', marginBottom: '8px' };

/**
 * The explanatory text know-your-customer-service attaches to a question.
 *
 * Two shapes arrive here, and the upstream `prompt` is what tells them apart. With one, the text is a "read more"
 * explainer long enough to want a dialog -- in the v4 NO template only the PEP question qualifies, and its prompt is
 * the link copy. Without one, the text is a short hint the customer needs *before* answering ("Flere svaralternativer
 * er mulig", "F.eks. Sverige, EU, FN"), so it belongs next to the question rather than behind an icon. v4 moved some
 * of these out of the question label, which is how they came to be missing from the page entirely.
 *
 * Only the dialog renders the text as HTML, which is also what keeps the service-supplied-markup trust boundary where
 * it already was.
 */
const KycQuestionInfo = ({ info }: Props) => {
    if (!info?.description) {
        return null;
    }

    if (info.label) {
        return <ShowDetailsModal label={info.label} dialogTitle={info.label} dialogContent={info.description} />;
    }

    return (
        <Typography variant="body2" sx={inlineStyles}>
            {info.description}
        </Typography>
    );
};

export default KycQuestionInfo;
